import React from "react";

const ErrorMessage = ({ error }) => <span style={{
  color: 'red',
  fontSize: '0.8rem',
}}>{error}</span>;

export default ErrorMessage;
